var app = angular.module('leonardo');

var AccountStatusFilter = function (AccountService) {
  return function (status) {
    if ((status !== null) && (status !== undefined) && (status !== ''))
      switch (status.toString()) {
        case AccountService.STATUS_PENDING:
          return 'Pending';
        case AccountService.STATUS_ACTIVE:
          return 'Active';
        case AccountService.STATUS_ON_BOARDING:
          return 'On boarding';
        case AccountService.STATUS_REJECTED:
          return 'Rejected';
      }
    return 'Invalid status, please contact admin.';
  };
};

var AccountInvitationStatusFilter = function (AccountInvitationService) {
  return function (status) {
    if ((status !== null) && (status !== undefined) && (status !== ''))
      switch (status.toString()) {
        case AccountInvitationService.STATUS_PENDING:
          return 'Pending';
        case AccountInvitationService.STATUS_ACCEPTED:
          return 'Accepted';
        case AccountInvitationService.STATUS_DECLINED:
          return 'Declined';
        case AccountInvitationService.STATUS_LOADING:
          return 'Loading';
      }
    return 'Invalid status';
  };
};

var AccountRequestStatusFilter = function (AccountRequestService) {
  return function (status) {
    if ((status !== null) && (status !== undefined) && (status !== ''))
      switch (status.toString()) {
        case AccountRequestService.STATUS_PENDING:
          return 'Pending';
        case AccountRequestService.STATUS_ACTIVE:
          return 'Active';
        case AccountRequestService.STATUS_REJECTED:
          return 'Rejected';
      }
    return 'Invalid status, please contact admin.';
  };
};

app.filter('accountRequestStatus', ['AccountRequestService', AccountRequestStatusFilter]);
app.filter('accountInvitationStatus', ['AccountInvitationService', AccountInvitationStatusFilter]);
app.filter('accountStatus', ['AccountService', AccountStatusFilter]);
